import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {SettingsState} from "./SettingsState";
import {SETTINGS_FETCHED} from "../../action/settings/actionType";

/**
 * Initial state for settings.
 */
const initState: SettingsState = {
	settings: none,
	boilerUnitCategoryId: none
};

const reducer = handleActions({
	[SETTINGS_FETCHED]: (state: SettingsState, action: Action<any>): SettingsState => {
		return {...state, settings: option(action.payload.settings)}
	}
}, initState);

export default reducer;
